import { motion } from 'framer-motion';
import { useCases } from '../../../mocks/agents';

export default function UseCases() {
  return (
    <section id="use-cases" className="py-32 bg-gradient-to-b from-black/50 to-cyber-dark relative">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl lg:text-6xl font-display font-bold text-white mb-4">
            Cas d'Usage par Secteur
          </h2>
          <p className="text-xl text-gray-400 font-body max-w-3xl mx-auto">
            Découvrez comment nos agents IA transforment différents secteurs d'activité
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {useCases.map((useCase, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-black/30 backdrop-blur-xl border border-white/10 rounded-3xl p-8 hover:border-cyber-blue/50 transition-all"
            >
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-cyber-blue/20 to-cyber-purple/20 rounded-2xl flex-shrink-0">
                  <i className={`${useCase.icon} text-3xl text-cyber-blue`}></i>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-2xl font-display font-bold text-white mb-4">
                    {useCase.sector}
                  </h3>
                  
                  <div className="flex flex-wrap gap-2 mb-4">
                    {useCase.agents.map((agent, i) => (
                      <span
                        key={i}
                        className="px-3 py-1 bg-cyber-purple/20 border border-cyber-purple/30 rounded-full text-xs text-gray-300 font-body"
                      >
                        {agent}
                      </span>
                    ))}
                  </div>
                  
                  <div className="flex items-center gap-2 text-cyber-blue font-body font-semibold">
                    <i className="ri-arrow-right-up-line"></i>
                    <span>{useCase.result}</span>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
